import styled from 'styled-components';

export const ResearchContainer = styled.div`
  width: 100%;
  height: 150px;
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 16px;
  border-radius: 8px;
  margin-top: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 10px;
    height: 142px;
  }
`;

export const ResearchWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.lightClearBlue};
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 16px;
    height: 122px;
    gap: 5px;
  }
`;

export const CyprusTabWrapperResponsive = styled.div`
  padding: 16px;
`;
